

function ShowDaneWeekendDay({sdaytype,sday}) {

  if(sdaytype=='weekend')  {
        return (<strong style={{color:'red'}}>{sday}</strong>)
    }
  else
    {
       return (<strong>{sday}</strong>)
    }
}

export default ShowDaneWeekendDay